function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  font-size: 18px;\n  font-weight: 300;\n  span:first-child {\n    font-weight: 400;\n  }\n  span:last-child {\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import propTypes from "prop-types";
import styled from "styled-components";
import formatCurrency from "../../../../utils/format-currency";
function AllocationDisplay(props) {
    var hours = props.hours, cost = props.cost, rest = _objectWithoutProperties(props, [
        "hours",
        "cost"
    ]);
    return /*#__PURE__*/ React.createElement("div", _extends({}, rest), /*#__PURE__*/ React.createElement("span", null, hours, "h"), /*#__PURE__*/ React.createElement("span", null, " / "), /*#__PURE__*/ React.createElement("span", null, formatCurrency(cost || 0)));
}
var StAllocationDisplay = styled(AllocationDisplay)(_templateObject());
AllocationDisplay.propTypes = {
    hours: propTypes.number,
    cost: propTypes.number
};
export default StAllocationDisplay;
